import {
  ContributorButtonsBar,
  OwnerButtonsBar,
} from './perspectivie-bottom.footer'
import { Article, Contribution } from '../types'
import {
  ReserveContributionInput,
  useReserveContributionMutation,
} from '../../../../../generated/graphql'
import { MessageType } from '../../../../../utils/message-type'
import Toast from 'react-native-root-toast'
import * as Sentry from '@sentry/react-native'
import { ContributionType } from '../../../../../generated/graphql'
import { useTranslation } from 'react-i18next'
import { useNode } from '../../../../../contexts/current-node.provider'
import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import {
  hasApolloErrorCode,
  ERROR_CODES,
} from '../../../../../utils/error-utils'

export const ContributionsButtonsBar = ({
  perspective,
  selection,
  setReservedContribution,
}: {
  perspective: Article
  selection: { start: number; end: number }
  setReservedContribution: (contribution: Contribution | null) => void
}) => {
  const [doReserveContribution] = useReserveContributionMutation()
  const { t } = useTranslation('perspective')
  const { userCorank } = useNode()

  const canContribute = useCallback(
    (perspective: Article) => {
      if (perspective.isOwner) {
        return true
      }
      if (perspective.minCoRank == null) {
        return true
      }

      if (userCorank == null) {
        return false
      }

      return +userCorank >= +perspective.minCoRank
    },
    [userCorank]
  )
  const createContribution = async (type: ContributionType) => {
    const { start, end } = selection
    if (end - start < 1 || !perspective) {
      Toast.show(t('wrong-selection'))
      return
    }
    if (!canContribute(perspective)) {
      Toast.show(
        t('minimum_co_rank', {
          coRank: userCorank,
          minCoRank: perspective.minCoRank,
        }),
        {
          duration: Toast.durations.LONG,
          position: Toast.positions.TOP,
          ...MessageType.error,
        }
      )
      return
    }
    const input: ReserveContributionInput = {
      articleId: perspective.id,
      begin: start,
      end,
      clusterId: perspective.clusterId,
      basedOnVersion: perspective.version,
      intendedType: type,
    }
    try {
      const result = await doReserveContribution({ variables: { input } })
      setReservedContribution(result.data!.reserveContribution || null)
    } catch (e) {
      if (
        e instanceof ApolloError &&
        hasApolloErrorCode(e, ERROR_CODES.PAYMENT_REQUIRED)
      ) {
        Toast.show(
          t('errors:node-active-user-limit-reached'),
          MessageType.error
        )
        return
      }
      Toast.show((e as Error).message, MessageType.error)
      console.error(e)
      Sentry.captureException(e)
    }
  }

  if (!perspective) {
    return null
  }
  if (perspective.isOwner) {
    return <OwnerButtonsBar onClick={createContribution} />
  }
  return <ContributorButtonsBar onClick={createContribution} />
}
